import { observable, action, makeObservable } from 'mobx';

// configure({ enforceActions: true});
class Store {
  open = null;
  data;

  constructor() {
    makeObservable(this, {
      open: observable,
      data: observable,
      setModal: action,
      setData: action
    });
  }

  setModal(modalName, data) {
    this.open = modalName;
    this.data = data;
  }

  setData(data) {
    this.data = data;
  }
}

const store = new Store();
export default store;
